import { store } from '../state/store'
import type { ActionResponse } from '../DTOs/Common/ErrorResponse'

export const mayQueueOffline = () => store.getState().authReducer.user?.canSyncOffline !== false

export const offlineRefusal = (): ActionResponse<null> => ({
  success: false,
  data: null,
  errors: [{ code: 0, description: 'Your changes need a connection, so they cannot be saved offline. Reconnect and try again.' }],
})
